export default ({ store }) => {
  if (!store.$auth.loggedIn) {
    store.commit(`companies/setUserCompanies`, null)
  }
}
